angular.module('cfn').provider('error-message.service', [
  '$injector',
  function($injector) {
    'use strict';

    var errors = [],
      rootScope;

    function clear() {
      errors = [];
    }

    /**
     * @param exception.message
     *      internationalized message, ready to be displayed for the user
     * @param exception.cause
     *      technical description / stack trace of what actually happened
     * @param exception.context
     *      route or path
     */
    function reportException(exception) {
      var error = {
        title: exception.message,
        description: exception.cause,
        context: exception.context
      };

      errors.push(error);

      rootScope.$broadcast('error-message.service_REPORT_ERROR', error);
    }

    function getLastError() {
      return (errors.length && errors[0]) || {};
    }

    function getErrors() {
      return errors.splice();
    }

    function getErrorsAsCopy() {
      return errors.slice();
    }

    return {
      $get: [
        '$rootScope', 'i18nFilter',
        function($rootScope, i18nFilter) {
          rootScope = $rootScope;
          rootScope.$on('error-message.service_REPORT_ERROR', function(event, data) {
            rootScope.alertController.addTemporaryAlert(
                i18nFilter('fe.standard.error'),
                'error'
            );
          });
          return {
            clear: clear,
            reportException: reportException,
            getLastError: getLastError,
            getErrors: getErrors,
            getErrorsAsCopy: getErrorsAsCopy
          };
        }
      ],
      clear: clear,
      reportException: reportException,
      getLastError: getLastError,
      getErrors: getErrors,
      getErrorsAsCopy: getErrorsAsCopy
    };
  }
]);
